import React, { useEffect, useState } from "react";
import { CssBaseline, Box, Typography } 
from "@mui/material";

import Dashboard from "../components/shared/dashboard/dashboard";
import MetaDecorator from "../services/meta_decorator";
import HealthProfileTabs from "../components/health_profile/health_profile_tabs";
import Newheader from "../components/shared/newheader";

import Footer from "../components/shared/footer";
import InactivityMeter from "../components/shared/inactivitymeter";
import { getApiUrl } from "../services/api_service";
import AccessLocalStorage from "../services/localStorage";
import CircularProgress from '@mui/material/CircularProgress';
//import { useStyles } from "../style";
import ShowMessage from "../components/shared/showmessage";
import { bodyBg2, dashboardText, fullHeight, name, paddingboxeven } from "../style2";

function Health_Profile() {
  //const classes = useStyles();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const defaulttab = window.location.hash ? parseInt(window.location.hash.substring(1), 10) : 0;
  const [profile, setProfile] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const ls = new AccessLocalStorage();

  useEffect(() => {
    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) {
      setError("Unauthorized. No token available.");
      setLoading(false);
      return;
    }
    setLoading(true);
    fetch(
      `${getApiUrl()}${process.env.REACT_APP_GET_PROFILE}/${ls.getCurrentPatientId()}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        
        setProfile(data);
      })
      .catch((err) => {
        console.log(err);
        setError(err.message || "An error occurred.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <Box sx={{ ...bodyBg2, ...fullHeight }}>
      <CssBaseline />
      <MetaDecorator title={"EnrichMyCare - Health Profile"} description={"Professional dashboard app"} />
      <Newheader fullWidth={true} tab_disabled={true} show_profile_button={true} show_back_button={true} />
      <Box  sx={{...dashboardText, marginTop: "2rem", marginBottom: "2rem" }}>
        <Typography component="div" sx={{...name, textAlign: "center", fontWeight: "bold" }} marginLeft={1}>
          Health Profile
        </Typography>
      </Box>
      {/* <Box mt={12} /> */}
      {/* <Header fullWidth={true} show_welcome_message={false} show_back_button={true} show_profile_button={false} /> */}
      <Dashboard fullWidth={true} profile_image={true} detail_text={true} share_icons={true} end_card={true} cards={false} />
      {loading ? <Box sx={paddingboxeven}>
        <Box pt={3} sx={{width: "100%", height: "300px", textAlign: "center", backgroundColor: "white", borderRadius: 9, }}>
          <CircularProgress />
          <Typography >Loading Health Profile...</Typography>
        </Box>
      </Box> : <HealthProfileTabs profile={profile} defaulttab={defaulttab} />}
      <InactivityMeter />
      <ShowMessage severity="error" message={error} />
      <Footer />
    </Box>
  );
}

export default Health_Profile;
